import {
  DialogCellConfig,
  IIdentity,
  NumericCellConfig,
  SelectCellConfig,
  TextCellConfig,
  DateCellConfig,
} from '.';

export type CellConfig<T extends IIdentity> =
  | TextCellConfig
  | NumericCellConfig
  | SelectCellConfig<T>
  | DialogCellConfig<T>
  | DateCellConfig;
